import { render, staticRenderFns } from "./rich-text.vue?vue&type=template&id=659dacda&scoped=true&"
import script from "./rich-text.vue?vue&type=script&lang=ts&"
export * from "./rich-text.vue?vue&type=script&lang=ts&"
import style0 from "./rich-text.vue?vue&type=style&index=0&id=659dacda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659dacda",
  null
  
)

export default component.exports